import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../../constants';
import { DiscountFormDto } from '../../../models/dto';
import { DiscountTypeEnum } from '@sweatpals/shared';

export interface PromocodeChipProps {
	data: DiscountFormDto;
}

export const PromocodeChip: FC<PromocodeChipProps> = props => {
	const { data: discount } = props;

	return (
		<Box
			sx={{
				p: '2px 8px',
				borderRadius: '100px',
				backgroundColor: Colors.white_a10,
			}}
		>
			<Typography
				sx={{
					color: Colors.white,
					fontFamily: 'Montserrat, sans-serif',
					fontSize: '13px',
					fontWeight: '500',
					lineHeight: '21px',
				}}
			>
				{discount.code?.toUpperCase()}
				{' • '}
				{`${discount?.type === DiscountTypeEnum.Fixed
					? `$${Math.floor((discount.amount ?? 0) / 100)}`
					: `${(discount.amount ?? 0)}%`
				}`}
			</Typography>
		</Box>
	);
};
